
const formatNumber = (number: string) => number.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')

const currency = (number: string) => formatNumber(number);

export { formatNumber, currency };
